/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Open_Artifact_PanelInputs */



/**
* | output |
* | --- |
* | "Open Artifact Panel" |
*
* @param {Chat_Open_Artifact_PanelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_open_artifact_panel = /** @type {((inputs?: Chat_Open_Artifact_PanelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Open_Artifact_PanelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Artefakt-Panel öffnen")
	return /** @type {LocalizedString} */ ("Open Artifact Panel")
});